module.exports = __webpack_public_path__ + "static/media/USDT_USDC_Cake.eeb9ddef.png";